import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import VueSession from 'vue-session'
import Header from '@/views/Header.vue'
import Footer from '@/views/Footer.vue'
import axios from 'axios'
import VueMask from 'v-mask'
Vue.use(VueMask);
import router from './router'
import $ from 'jquery'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../static/assets/css/main.css'
import VueConfirmDialog from "vue-confirm-dialog";
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'

Vue.use(VueMaterial)

Vue.use(VueConfirmDialog);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueToast);
Vue.component('vue-header', Header)
Vue.component('vue-footer', Footer)
Vue.use(VueSession, {
  persist: true
})
const http = axios.create({
  baseURL: '',
  headers: {'Content-Type': 'application/json', 'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone},
});
window.axios = http;

Vue.config.productionTip = false

new Vue({
  router,
  $,
  render: h => h(App)
}).$mount('#app')
